import SpaceY from '../../../components/SpaceY';
import { MAX_WIDTH_639PX } from '../../../utils/common';
import useClientMediaQuery from '../../../utils/hook/useClientMediaQuery';

import MissionFirstSection from './MissionFirstSection';
import MissionRescue from './MissionRescue';
import MissionSecondSection from './MissionSecondSection';
import MissionThirdSection from './MissionThirdSection';

const MissionFirstTab = ({
  handleTabToSourcing,
}: {
  handleTabToSourcing: () => void;
}) => {
  const isMobile = useClientMediaQuery({ query: MAX_WIDTH_639PX });

  return (
    <div className="mx-auto max-w-screen-lg px-16px">
      <SpaceY height={72} />
      <MissionRescue />

      <SpaceY height={120} />
      <MissionFirstSection />

      <SpaceY height={120} />
      <MissionSecondSection />

      <SpaceY height={120} />
      <MissionThirdSection handleTabToSourcing={handleTabToSourcing} />

      <SpaceY height={isMobile ? 72 : 120} />
    </div>
  );
};

export default MissionFirstTab;
